module.exports = __webpack_public_path__ + "img/mockup-fineheart.b1e28f26.png";